__turbopack_context__.v({
  "accordion-item": "AccordionItem-module-scss-module__u4_g2W__accordion-item",
});
